//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  mapState,
  mapMutations
} from 'vuex'
import {
  cartInfo,
  orderPlace,
  updateCart,
  getCartNum,
  campaignRule,
  userInfo,
  getAddress,
  getArea

} from '@/service/index'

export default {
  data() {
    return {
      multipleSelection: [],
      tempSelection: [],
      centerDialogVisible: false,
      deleteVisible: false,
      addressVisible: false,
      init:true,
      addresses: [],
      selectedDeletePro: {},
      total: 0,
      allQty: 0,
      selectAll: false,
      cartInfoList: [],
      rule: {},
      isLoading: true,
      point: null,
      points: null,
      address: ''
    }
  },
  computed: {
    ...mapState([
      'global', 'categories', 'campaign', 'bread', 'goods'
    ]),
  },
  methods: {
    ...mapMutations({
      initCartNum: 'INIT_CART_NUM',
    }),
    async getUserInfo() {
      const res = await userInfo(this.$route.query.cid)
      if (res.status === 0) {
        this.point = res.data.point
        this.points = res.data.points
        //          this.recordUserinfo(res.data)
      }
    },
    clearFocus(self) {
      window.document.activeElement.blur()
    },
    goToDetails(productId) {
      this.$router.push({
        name: 'goodDetail',
        query: {
          id: productId,
          cid: this.$route.query.cid
        }
      });
    },
    toggleSelection(rows, type) {
      if (type == 'button') {
        if (!this.selectAll) {
          this.selectAll = true;
          for (let i = 0; i < this.cartInfoList.length; i++) {
            this.$refs.multipleTable.toggleRowSelection(this.cartInfoList[i], true);
          }
        } else {
          this.selectAll = false
          this.$refs.multipleTable.clearSelection();
        }

      } else {
        if (this.tempSelection.length > 0) {
          for (let i = 0; i < this.cartInfoList.length; i++) {
            for (let j = 0; j < this.tempSelection.length; j++) {
              if (this.cartInfoList[i].id === this.tempSelection[j].id) {
                this.$refs.multipleTable.toggleRowSelection(this.cartInfoList[i], true);
              }
            }
          }
        }
      }






      // if (this.selectAll) {
      //   this.selectAll = false
      //   this.$refs.multipleTable.clearSelection();
      // } else if (!this.selectAll) {

      // }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      // console.log('multipleSelection22222', this.multipleSelection)

      if (this.multipleSelection.length == this.cartInfoList.length) {
        this.selectAll = true;
      } else {
        this.selectAll = false;
      }
      //console.log('this.multipleSelection',this.multipleSelection)
      this.total = 0;
      this.allQty = 0;
      val.forEach(item => {
        this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
        this.allQty += item.qty;
      })
    },
    async changeCount(row) {
      const param = {};
      param.items = [];
      param.items.push({
        qty: row.qty,
        productId: row.productId
      })
      const res = await updateCart(this.$route.query.cid, param)
      if (res.status === 0) {
        this.total = 0;
        this.allQty = 0;
        this.$refs.multipleTable.selection.forEach(item => {
          this.total = this.total + parseFloat(item.price) * parseInt(item.qty);
          this.allQty += item.qty;
        })
        const cartRes = await getCartNum(this.$route.query.cid)
        this.initCartNum({
          cartNum: cartRes.data
        })
      } else {
        row.qty = row.qty - 1;
        if (res.status === 2) {
          this.$message(this.$t("cartMsg.lackall"));
        } else if (res.status === 3) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.lackall"));
        } else if (res.status === 4) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.globalamount"));
        } else if (res.status === 5) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.perskuqty"));

        } else if (res.status === 6) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.globalqty"));

        } else if (res.status === 7) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.typeqty"));

        } else if (res.status === 8) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.catqty"));

        } else if (res.status === 9) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.orderqty"));

        } else if (res.status === 10) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.pointlack"));
        } else if (res.status === 11) {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.personalamount"));
        } else {
          this.submitFlag = false
          this.$message(this.$t("cartMsg.retry"));
        }
      }
    },
    submitData() {
      this.getAddress()
    },
    onSubmitData() {
      if (this.address == '') {
        this.$message(this.$t("cartMsg.address"));
      } else {
        this.addressVisible = false
        if (this.rule.orderQty === -1 || this.rule.orderQty === 100000) {
          this.orderPlace()
        } else {
          this.centerDialogVisible = true;
        }
      }
    },
    submitFilter(data) {
      return data / 1 === 0;
    },
    goBack() {
      //        goback可能不存在
      this.$router.push({
        path: `/home/${this.$route.query.cid}`,
        query: {
          cid: this.$route.query.cid
        }
      })
    },
    async getAddress() {
      const res = await getAddress();
      const res1 = await getArea();

      // this.addressVisible = true
      // this.addresses = ['上海','香港']
      if (res.status === 0 && res.data && res.data.length > 0) {
        this.addressVisible = true
        this.addresses = res.data
      } else {
        if (this.rule.orderQty === -1 || this.rule.orderQty === 100000 || res1.data !== "hk") {
          this.orderPlace()
        } else {
          this.centerDialogVisible = true;
        }
      }
    },

    async getCartInfo() {
      const res = await cartInfo(this.$route.query.cid);
      this.isLoading = false
      if (res.status === 0) {
        this.cartInfoList = res.data


        this.$nextTick(function () {
          this.toggleSelection()

          if (this.init) {
            this.selectAll = true;
            this.init = false
            for (let i = 0; i < this.cartInfoList.length; i++) {
              this.$refs.multipleTable.toggleRowSelection(this.cartInfoList[i], true);
            }
          }




        })
      }
    },
    async getCampaignRuleInfo() {
      const res = await campaignRule(this.$route.query.cid);
      if (res.status === 0) {
        this.rule = res.data
      }
    },
    async orderPlace() {
      this.centerDialogVisible = false
      const param = {};
      param.items = [];
      if (this.address != '') {
        param.address = this.address;
      }
      this.multipleSelection.map(item => {
        param.items.push({
          productId: item.productId,
          qty: item.qty
        })
      })
      const res = await orderPlace(this.$route.query.cid, param);
      if (res.status === 0) {
        this.$router.push({
          path: `/orderDetail/${res.data.order.id}`,
          query: {
            cid: this.$route.query.cid
          }
        })
        const cartRes = await getCartNum(this.$route.query.cid)
        this.initCartNum({
          cartNum: cartRes.data
        })
      } else if (res.status === 2) {
        this.$message(this.$t("placeorder.lack"));
        const obj = this;
        setTimeout(
          function () {
            obj.$router.push({
              path: `/orderDetail/${res.data.order.id}`,
              query: {
                cid: obj.$route.query.cid
              }
            });
          }, 3000)
        const cartRes = await getCartNum(this.$route.query.cid)
        this.initCartNum({
          cartNum: cartRes.data
        })
      } else if (res.status === 3) {
        this.$message(this.$t("placeorder.lackall"));
      } else if (res.status === 4) {
        this.$message(this.$t("placeorder.globalamount"));
      } else if (res.status === 5) {
        this.$message(this.$t("placeorder.perskuqty"));
      } else if (res.status === 6) {
        this.$message(this.$t("placeorder.globalqty"));
      } else if (res.status === 7) {
        this.$message(this.$t("placeorder.typeqty"));
      } else if (res.status === 8) {
        this.$message(this.$t("placeorder.catqty"));
      } else if (res.status === 9) {
        this.$message(this.$t("placeorder.orderqty"));
      } else if (res.status === 10) {
        this.$message(this.$t("placeorder.pointlack"));
      } else if (res.status === 11) {
        this.$message(this.$t("placeorder.personalamount"));
      } else {
        this.$message(this.$t("placeorder.retry"));
      }
    },
    selectDelete(item) {
      this.deleteVisible = true
      this.selectedDeletePro = item;
    },
    keepLang() {
      let locale = localStorage.locale;
      this.$i18n.locale = locale === 'en' ? locale : 'zh';
    },
    async deletePro() {
      this.deleteVisible = false;
      this.tempSelection = this.multipleSelection;
      const param = {};
      param.items = [];
      param.items.push({
        qty: 0,
        productId: this.selectedDeletePro.productId
      })
      const res = await updateCart(this.$route.query.cid, param)
      if (res.status === 0) {
        this.$message({
          message: 'Success',
          type: 'success'
        })
        const cartRes = await getCartNum(this.$route.query.cid)
        this.initCartNum({
          cartNum: cartRes.data
        })
        this.getCartInfo()
      }
    }
  },
  mounted() {
    this.getUserInfo();
    this.getCartInfo();
    this.getCampaignRuleInfo();
    this.keepLang();

  },

}




// WEBPACK FOOTER //
// ./src/pages/cart/CartPc.vue